<template>
	<div>
		<iframe v-if="clicarCliente == true" id="pp" style="position: absolute; width:0; height:0; border:0"
			:src=this.htmlFrame></iframe>
		<div class="row fl-row-tabela">
			<div class="col-md-12">
				<div class="table-responsive card card-table">
					<table :class="tableClass" class="table fl-table table-borderless table-hover">
						<thead>
							<tr>
								<th :class="column.class" :style="column.style" :width="column.width"
									v-for="(column, index) in columns" :key="index">

									<a v-if="column.sortable" href="#" @click.prevent="ordernar(column.key)">
										<fa-icon icon="sort" v-show="tabela.column != column.key" />
										<fa-icon icon="sort-alpha-down"
											v-show="tabela.column == column.key && tabela.inverse == 'asc'" />
										<fa-icon icon="sort-alpha-up"
											v-show="tabela.column == column.key && tabela.inverse == 'desc'" />
										{{ column.name }}
									</a>

									<div v-else>
										{{ column.name }}
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in tabela.listaChunk[tabela.pagination.currentPage - 1]"
								:key="index">
								<td v-for="(column, indexColumn) in item.columns" :key="indexColumn"
									:style="column.style" :class="column.class">
									<span v-if="column.clickable">
										<a href="#" v-if="column.event" @click.prevent="$emit(column.event, item)">
											<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
											<span v-if="column.html" v-html="column.html"></span>
										</a>

										<a v-if="column.link && perfisUsuario.includes(11)" :href="column.link" :target="column.target"
											@click.prevent="clicaCliente(column.link)">
											<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
											<span v-if="column.html" v-html="column.html"></span>
										</a>

									</span>
									<span v-else>
										<span v-if="column.array">
											<span v-for="(itArray, indexArray) in column.array" :key="indexArray"
												v-html="itArray"></span>
										</span>
										<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
										<span v-if="column.html" v-html="column.html"></span>
										<span v-else>{{ column.value }}</span>
									</span>

								</td>
							</tr>
						</tbody>
						<tfoot v-if="!tabela.listaChunk[tabela.pagination.currentPage - 1]">
							<tr>
								<td :colspan="columns.length">
									Nenhum registro encontrado.
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-12">
				<nav aria-label="Page navigation">
					<ul class="pagination-margin pagination pagination-sm justify-content-center" style="margin:0px">
						<li class="page-item" :class="{ 'disabled': tabela.pagination.currentPage == 1 }">
							<a class="page-link" href="#" @click.prevent="previous">
								<span aria-hidden="true">
									<fa-icon icon="angle-left" />
								</span>
							</a>
						</li>
						<li class="page-item" v-for="item in  tabela.pagination.pageNumbers" :key="item"
							:class="{ 'active': item == tabela.pagination.currentPage }">
							<a href="#" class="page-link" @click.prevent="page(item)">{{ item }}</a>
						</li>
						<li class="page-item"
							:class="{ 'disabled': tabela.pagination.currentPage == tabela.pagination.totalPages }">
							<a href="#" class="page-link" @click.prevent="next">
								<span aria-hidden="true"><fa-icon icon="angle-right" /></span>
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>

import _ from 'lodash';
import axios from '../../routers/axios';
import $ from "jquery";

/*

columns: [{
	class: "",
	style: "",
	width: "",
	sortable: "",
	key: "",
	name "",
}]

list: [{
	columns: [{
		event: "",
		clickable: "",
		icon: "",
		styleIcon: "",
		html: "",
		value: "",
		style: "",
		class: "",
		array: [], // renderiza o html que estiver dentro da array
	}],
	_object: []


}]
*/
var jwt_token = require('jwt-decode')
export default {

	props: {
		columns: {
			type: Array,
			required: true,
		},

		tableClass: {
			type: String,
			required: false,
		},

		columnStartSortable: {
			type: String,
			required: true
		},

		perPage: {
			type: Number,
			required: true,
		},

		showPerPage: {
			type: Boolean,
			default: true,
		}
	},

	data() {
		return {
			tabela: {
				lista: [],
				listaChunk: [],
				inverse: "asc",
				busca: "",
				column: '',
				columns: [],
				bouse: false,

				pagination: {
					currentPage: 1,
					totalPages: 0,
					totalItens: 0,
					pageNumbers: [],
				}
			},
			clicarCliente: false,
			iniciaTeste: false,
			htmlFrame: '',
			listaPerfil: [],
			perfisUsuario: []
		}
	},

	mounted() {
		axios.get(this._getUrl("/api/acesso/" + JSON.parse(sessionStorage.getItem('_LOCAL_SESSION_SERVICO_')).id)).then(response => {
			this.listaPerfil = response.data

			for (var i = 0; i < this.listaPerfil.length; i++) {
				this.perfisUsuario.push(this.listaPerfil[i].id)
			}
		});
	},

	beforeDestroy() {
		//	this.clicarCliente = false
		this.iniciaTeste = false
		//	this.htmlFrame = ''
	},

	methods: {

		loadTable(list) {
			// pega todos os campos que são buscaveis ou ordenaveis
			let itens = _.filter(this.columns, o => { return o.sortable || o.searchable }).map(o => { return o.key })

			// adiciona esses itens na coluna da tabela
			this.tabela.columns = itens

			// coloca os itens filtraveis na tabela para gerar a lista
			this.tabela.lista = list.map(item => {

				for (var i in itens) {
					item[itens[i]] = item._object[itens[i]]
				}

				return item
			})
			this.tabela.pagination.currentPage = 1
			this.tabela.column = this.columnStartSortable
			this.filtraCore()
		},

		clicaCliente(htmlF) {
			this.htmlFrame = htmlF
			this.clicarCliente = true
				var token = JSON.parse(sessionStorage.getItem('_LOCAL_SESSION_SERVICO_')).token
				var dadosResp = jwt_token(token)

				var data = {
					login: dadosResp.loginf,
					senha: dadosResp.senhaf
				}

				if(this.htmlFrame.slice(-1) !== '/')
					this.htmlFrame+='/'
				
				$.ajax({
					type: 'POST',
					url: `${this.htmlFrame}ws/public/Usuario/logar`,
					data: { data: JSON.stringify(data) },
					dataType: 'json',
					success: function (retorno) {
						var dados = jwt_token(retorno.token)
						var session = {
							token: retorno.token,
							nome: dados.nome,
							cpf: dados.cpf,
							login: dados.login,
							exp: dados.exp,
							cargo: dados.cargo,
							departamento: dados.departamento,
							email: dados.email,
							login_services: true,
							id_usuario: dados.id_usuario,
							telefone: dados.telefone,
							telefone2: dados.telefone2,
							msg: false,
							privilegios: dados.privis,
							area: null,
							foto: dados.foto,
							id_orgao: dados.id_orgao,
							trigrama: dados.trigrama,
							anac: dados.codigo_anac,
							desenvolvedor: dados.desenvolvedor == '0' ? false : true
						}

						var string = JSON.stringify(session)

						sessionStorage.setItem('_POLICE_SESSION_', string)
						window.addEventListener("message", function (message) {
							alert(message.data);
						});
						
					},
					error: function (e) {
						rt._request = false
						rt.erro = e
						//callback(rt)
						bus.$emit('modal-erro-show', e, this.getURL_WS(url))
					}
				})
				this.test()

				window.setTimeout(function () {

				// Move to a new location or you can do something else
					window.location.href = htmlF

				}, 5000);
		},



		test() {

			this.iniciaTeste = true
			var doc = {}
			doc = document.getElementById('pp')
			if (doc)
				doc.contentWindow.postMessage(sessionStorage.getItem('_POLICE_SESSION_'), "*");

			this.iniciaBuscaDados()
		},

		iniciaBuscaDados() {

			if (this.iniciaTeste == true) {
				setTimeout(() => {
					this.test()
				}, 100)
			}
		},


		atualizaItem(item, key, id) {

			let index = _.findIndex(this.tabela.lista, o => { return o._object[key] == id })

			if (index < 0) {
				this.tabela.lista.push(item)
			} else {
				this.tabela.lista[index] = item
			}

			this.loadTable(this.tabela.lista)
		},

		excluirItem(item, key, id) {

			let index = _.findIndex(this.tabela.lista, o => { return o._object[key] == id })
			this.tabela.lista.splice(index, 1)
			this.loadTable(this.tabela.lista)
		},

		filtraLista(busca) {

			this.tabela.busca = busca
			this.filtra()
		},

		filtra() {
			if (this.tabela.bouse == false) {
				this.tabela.bouse = true
				_.delay(() => {
					this.tabela.pagination.currentPage = 1
					this.filtraCore()

					if (this.tabela.bouse == true) {
						this.tabela.bouse = false
					}
				}, 500, 'later');
			}
		},

		filtraCore() {
			let filtrado = []
			this.tabela.lista = this.tabela.lista.map((item, index) => {
				item._index = index
				item._exibir = false
				return item
			})

			if (this.tabela.busca.trim() != "") {
				filtrado = _.filter(this.tabela.lista, (item) => {
					return this.tabela.columns.some((column) => {
						let it = item[column] + ''
						return it.toLowerCase().indexOf(this.tabela.busca.toLowerCase()) > -1
					});
				});

				filtrado = _.orderBy(filtrado, [this.tabela.column], [this.tabela.inverse]);
			} else {

				// apenas filta a lista
				filtrado = _.orderBy(this.tabela.lista, [this.tabela.column], [this.tabela.inverse]);
			}
			this.setDataLista(filtrado)
		},

		// seta a tabela a ser visualizada
		setDataLista(lista) {

			let listAxu = []
			this.tabela.listaChunk = []

			for (var i in lista) {
				listAxu.push({ _index: Number(lista[i]._index) })
			}

			this.tabela.listaChunk = _.chunk(lista, this.perPage)
			// está fazendo o for na lista sem está filtrada, por isso não tá exibindo
			// tem que fazer uma matris e manipular a lista

			this.tabela.pagination.totalItens = this.tabela.lista.length;
			this.tabela.pagination.totalPages = Math.ceil(this.tabela.pagination.totalItens / this.perPage)

			let temp = [];
			for (let i = 1; i <= this.tabela.listaChunk.length; i++) {
				temp.push(i);
			}
			this.tabela.pagination.pageNumbers = temp
		},

		// exibe os itens filtrados da lista
		exibeLista(posicao) {
			let len = this.tabela.lista.length;
			for (let i = 0; i < len; i++) {
				this.tabela.lista[i]._exibir = false
			}

			if (!_.isNil(this.tabela.listaChunk[posicao])) {
				for (let i = 0; i < this.tabela.listaChunk[posicao].length; i++) {
					for (let j = 0; j < len; j++) {
						if (this.tabela.listaChunk[posicao][i]._index == this.tabela.lista[j]._index) {
							this.tabela.lista[j]._exibir = true
							break
						}
					}
				}
			}
		},

		ordernar(coluna) {

			this.tabela.column = coluna;

			if (this.tabela.inverse == 'asc') {
				this.tabela.inverse = 'desc'
			} else {
				this.tabela.inverse = 'asc'
			}

			this.tabela.pagination.currentPage = 1

			this.filtra();
		},

		// quando clica no número da páginação
		page(page) {
			this.tabela.pagination.currentPage = page;
			this.exibeLista(page - 1)
		},

		// quando clica na seta de próximo
		next() {

			if (this.tabela.pagination.currentPage == this.tabela.pagination.totalPages) {
				return false;
			}

			this.tabela.pagination.currentPage = this.tabela.pagination.currentPage + 1

			this.exibeLista(this.tabela.pagination.currentPage - 1)
		},

		// quando clica na seta de voltar
		previous() {


			if (this.tabela.pagination.currentPage == 1) {
				return false
			}

			this.tabela.pagination.currentPage = this.tabela.pagination.currentPage - 1
			this.exibeLista(this.tabela.pagination.currentPage - 1)
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/table/main.vue